import { createActions as actionCreator, createReducer as reducerCreator } from 'reduxsauce';

// Facade for action creators and reducers
export const createActions = (actions: Record<string, string[]>) => actionCreator(actions);

// @ts-ignore
export const createReducer = (initialState, handlers) => reducerCreator(initialState, handlers);
